import React from 'react';
import { CheckIcon } from 'lucide-react';
import { summaryRows } from '../data/summary';
import { price, productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function SummaryTable() {
  return <section className="bg-stage-warm contour-lines py-16 sm:py-20" aria-labelledby="summary-title" data-id="element-220" data-mp="o71jkm7hsj9a">
      <div className="mx-auto max-w-4xl px-4" data-id="element-221" data-mp="j8huwe1iktd8">
        <h2 id="summary-title" className="text-center text-3xl font-extrabold text-forestDeep sm:text-4xl" data-id="element-222" data-mp="1guxcrgxurt1b">
          Everything included
        </h2>
        <p className="mt-3 text-center text-inkSoft" data-id="element-223" data-mp="1bx5l8o14e8xn">
          {productShortName} · {totalVolumes} volumes + {totalBonuses} bonuses ·{' '}
          <b className="text-forest" data-id="element-224" data-mp="16ym02pucp16c">{price}</b>
        </p>

        <ul className="mt-10 grid gap-3 sm:grid-cols-2" data-id="element-225" data-mp="12ue88jslj53w">
          {summaryRows.map(([feature, detail]) => <li key={feature} className="flex gap-3 rounded-lg border border-line bg-white p-4 shadow-card" data-id="element-226" data-mp="3robcyxbhucwe">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-forest" data-id="element-227" data-mp="3nnhpg51yr041">
                <CheckIcon className="h-3.5 w-3.5 text-goldBright" aria-hidden="true" data-id="element-228" data-mp="3ib3anlcensgd" />
              </span>
              <p data-id="element-229" data-mp="39c80xza5k08b">
                <b className="block text-sm text-forestDeep" data-id="element-230" data-mp="39craospnfib9">{feature}</b>
                <span className="text-sm text-inkSoft" data-id="element-231" data-mp="3ddtabanh9wdr">{detail}</span>
              </p>
            </li>)}
        </ul>

        <blockquote className="mx-auto mt-10 max-w-2xl rounded-xl border-l-4 border-gold bg-white px-6 py-5 text-center text-lg font-bold leading-relaxed text-forestDeep shadow-card" data-id="element-232" data-mp="2zlwp7qk88mqv">
          “The best time to have these materials was at the start of your year. The second-best time is today.”
        </blockquote>
      </div>
    </section>;
}